// User validation utilities

export const validateUsername = (username) => {
  if (!username || username.trim() === '') {
    return { valid: false, error: 'El nombre de usuario es requerido' };
  }
  
  if (username.length < 3) {
    return { valid: false, error: 'El nombre de usuario debe tener al menos 3 caracteres' };
  }
  
  if (username.length > 20) {
    return { valid: false, error: 'El nombre de usuario no debe superar 20 caracteres' };
  }
  
  // Only alphanumeric and underscore
  if (!/^[a-zA-Z0-9_]+$/.test(username)) {
    return { valid: false, error: 'Solo se permiten letras, números y guión bajo' };
  }
  
  return { valid: true };
};

export const validatePassword = (password, isRequired = true) => {
  if (!password || password.trim() === '') {
    if (isRequired) {
      return { valid: false, error: 'La contraseña es requerida' };
    }
    return { valid: true }; // Optional for edits
  }
  
  if (password.length < 6) {
    return { valid: false, error: 'La contraseña debe tener al menos 6 caracteres' };
  }
  
  if (password.length > 50) {
    return { valid: false, error: 'La contraseña no debe superar 50 caracteres' };
  }
  
  return { valid: true };
};

export const validateEmail = (email) => {
  if (!email || email.trim() === '') {
    return { valid: true }; // Email is optional
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { valid: false, error: 'Email inválido' };
  }
  
  return { valid: true };
};

export const validateName = (name, fieldName = 'nombre') => {
  if (!name || name.trim() === '') {
    return { valid: false, error: `El ${fieldName} es requerido` };
  }
  
  if (name.length < 2) {
    return { valid: false, error: `El ${fieldName} debe tener al menos 2 caracteres` };
  }
  
  if (name.length > 50) {
    return { valid: false, error: `El ${fieldName} no debe superar 50 caracteres` };
  }
  
  return { valid: true };
};

export const validateUserForm = (formData, isEdit = false) => {
  const errors = {};
  
  // Username
  const usernameValidation = validateUsername(formData.username);
  if (!usernameValidation.valid) {
    errors.username = usernameValidation.error;
  }
  
  // Password (required only for new users)
  const passwordValidation = validatePassword(formData.password, !isEdit);
  if (!passwordValidation.valid) {
    errors.password = passwordValidation.error;
  }
  
  // Nombre
  const nombreValidation = validateName(formData.nombre, 'nombre');
  if (!nombreValidation.valid) {
    errors.nombre = nombreValidation.error;
  }
  
  // Apellido
  const apellidoValidation = validateName(formData.apellido, 'apellido');
  if (!apellidoValidation.valid) {
    errors.apellido = apellidoValidation.error;
  }
  
  // Email
  const emailValidation = validateEmail(formData.email);
  if (!emailValidation.valid) {
    errors.email = emailValidation.error;
  }
  
  return {
    valid: Object.keys(errors).length === 0,
    errors
  };
};

// Role utilities - ✅ MULTI-TENANT: Coincide con user_companies.role
export const ROLES = {
  SUPER_ADMIN:   'super_admin',    // ✅ Super Admin (dueño del sistema)
  COMPANY_ADMIN: 'company_admin',  // ✅ Administrador de la compañía
  RRHH:          'rrhh',           // ✅ Recursos Humanos
  MANAGER:       'manager',        // ✅ Manager de departamento
  EMPLOYEE:      'employee'        // ✅ Empleado
};

export const ROLE_LABELS = {
  super_admin:   'Super Admin',           // ✅ Dueño del sistema
  company_admin: 'Administrador',         // ✅ Administrador de la compañía
  rrhh:          'RRHH',                  // ✅ Recursos Humanos
  manager:       'Manager',              // ✅ Manager de departamento
  employee:      'Empleado',             // ✅ Empleado
  sin_asignar:   'Sin Asignar'           // ✅ Para usuarios sin rol
};

export const ROLE_DESCRIPTIONS = {
  super_admin:   'Acceso total al sistema y todas las compañías',
  company_admin: 'Administrador de la compañía, acceso completo a su empresa',
  rrhh:          'Gestiona empleados, nóminas y aprueba solicitudes',
  manager:       'Supervisa empleados y puede aprobar algunas solicitudes',
  employee:      'Acceso básico de solo lectura'
};

export const getRoleLabel = (role) => {
  return ROLE_LABELS[role] || role;
};

export const getRoleDescription = (role) => {
  return ROLE_DESCRIPTIONS[role] || '';
};

// Status utilities
export const STATUS = {
  ACTIVO: 'activo',
  INACTIVO: 'inactivo'
};

export const getStatusColor = (status) => {
  return status === 'activo'
    ? 'bg-green-100 text-green-700'
    : 'bg-red-100 text-red-700';
};

export const getRoleColor = (role) => {
  switch (role) {
    case 'super_admin':
      return 'bg-purple-100 text-purple-700';
    case 'rrhh':
      return 'bg-red-100 text-red-700';
    case 'supervisor':
      return 'bg-blue-100 text-blue-700';
    case 'employee':
      return 'bg-gray-100 text-gray-700';
    case 'sin_asignar':
      return 'bg-yellow-100 text-yellow-700';
    default:
      return 'bg-gray-100 text-gray-700';
  }
};
